import moment from "moment";

import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";

type DateLevel = "year" | "month" | "week" | "day";

interface IDateQuickLinkAddControlProps {
    id: string;
    value: Date;
    onClick(date: DateTimeWithPrecision): void;
    numbersToRender: { value: number, dateLevel: DateLevel }[];
    style?: React.CSSProperties;
}
class DateQuickLinkAddControl extends React.Component<IDateQuickLinkAddControlProps, never> {
    public render(): JSX.Element {
        const style = this.props.style ? this.props.style : {};
        return (
            <div className="date-quick-add-links" style={style}>
                {this.props.numbersToRender.map((val, index) => (
                    <a key={this.props.id + "-" + index} onClick={() => this.onAddTimeToValue(val.value, val.dateLevel)}>
                        {this.renderLabel(val.value, val.dateLevel)}
                    </a>
                ))}
            </div>
        );
    }

    private onAddTimeToValue(relativeAmountToAdd: number, dateLevel: DateLevel): void {
        const date = moment();
        const dateAdded = date.add(relativeAmountToAdd, dateLevel).toDate();
        const s = new DateTimeWithPrecision(dateAdded.format("YYYY-MM-DD"), "", LifeStageDatePrecisionEnum.MonthYear);
        this.props.onClick(s);
    }

    private renderLabel(value: number, dateLevel: DateLevel): string {
        let dateAbbrev = cacheStore.GetString("YearAbbrevLabel");
        switch (dateLevel) {
            case "day":
                dateAbbrev = cacheStore.GetString("DayAbbrevLabel");
                break;
            case "week":
                dateAbbrev = cacheStore.GetString("WeekAbbrevLabel");
                break;
            case "month":
                dateAbbrev = cacheStore.GetString("MonthAbbrevLabel");
                break;
        }

        return (value >= 0 ? "+" : "-") + value.toString() + dateAbbrev;
    }
}

export { DateQuickLinkAddControl };
